/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Api_Errors_File_Too_LargeInputs */

const nl_file_upload_api_errors_file_too_large = /** @type {(inputs: File_Upload_Api_Errors_File_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het bestand is te groot om te uploaden.`)
};

/**

* @param {File_Upload_Api_Errors_File_Too_LargeInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const file_upload_api_errors_file_too_large = /** @type {((inputs?: File_Upload_Api_Errors_File_Too_LargeInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Api_Errors_File_Too_LargeInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_file_upload_api_errors_file_too_large(inputs)
});
export { file_upload_api_errors_file_too_large as "file_upload.api_errors.file_too_large" }